import type { ComponentType } from 'react'
import React from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'

type Hoist<T> = Omit<
  T,
  | 'contextType'
  | 'defaultProps'
  | 'displayName'
  | 'propTypes'
  | 'Symbol'
  | 'apply'
  | 'arguments'
  | 'bind'
  | 'call'
  | 'caller'
  | 'length'
  | 'name'
  | 'prototype'
  | 'toString'
>

export function withBoundProps<P, E>(useCtx: (props: P) => E) {
  return function <PP extends P, S>(CMP: ComponentType<PP & E> & S) {
    const NCMP = props => {
      const ctxData = useCtx(props)
      return <CMP {...ctxData} {...props} />
    }

    hoistNonReactStatics(NCMP, CMP)
    NCMP.displayName = `withBoundProps(${CMP.displayName || CMP.name})`

    return NCMP as ComponentType<Omit<PP, keyof E>> & Hoist<S>
  }
}
